export default "__VITE_ASSET__BuaxJYLj__"